<template>
    <v-tooltip v-if="isNonPartner" bottom max-width="420">
        <template v-slot:activator="{ on }">
            <v-chip
                class="rounded px-2 py-2 mb-1 white--text w-full"
                color="orange darken-2"
                small
                :href="item.restaurantNonPartnerMenuUrl || undefined"
                :target="
                    item.restaurantNonPartnerMenuUrl ? '_blank' : undefined
                "
                :rel="item.restaurantNonPartnerMenuUrl ? 'noopener' : undefined"
                v-on="on"
            >
                {{ $t('labels.non_partner') }}
            </v-chip>
        </template>
        <div>
            <div v-if="item.restaurantNonPartnerMenuUrl">
                <strong>{{ $t('labels.non_partner_menu_url') }}:</strong>
                {{ item.restaurantNonPartnerMenuUrl }}
            </div>
            <div v-if="item.restaurantNonPartnerNotes" class="text-pre-wrap">
                <strong>{{ $t('labels.non_partner_notes') }}:</strong>
                {{ item.restaurantNonPartnerNotes }}
            </div>
        </div>
    </v-tooltip>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isNonPartner() {
            return this.item.restaurantThirdPartyType === 'non_partner'
        },
    },
}
</script>

<style scoped>
.text-pre-wrap {
    white-space: pre-wrap;
}
</style>
